<script setup>
import { AppDropdown, AppDropdownItem } from '@/components/molecules/AppDropdown'
import AppButton from '@/components/atoms/AppButton'
import { useBatchStore } from '@/stores/BatchStore'
import { useConfigStore } from '@/stores/ConfigStore'
import { icons } from '@/helpers/icons'

defineProps({
  isBatchDetailsFlow: Boolean,
})

defineEmits([
  'addToCurrentBatch',
  'createNewBatch',
  'cdpBatchesSearch',
  'closeSidebar',
])

const batchStore = useBatchStore()
const configStore = useConfigStore()
</script>

<template>
  <AppDropdown placement="bottom-start" width="w-max">
    <template #trigger>
      <AppButton
        variant="header"
        rounded="full"
        class="flex-grow"
        :disabled="!configStore.getConfigField('hasActiveSubscription')"
        @click="$emit('closeSidebar')"
      >
        <span v-html="icons.card_add" class="flex items-center" />
        <span class="font-semibold whitespace-nowrap">Add Cards</span>
      </AppButton>
    </template>

    <AppDropdownItem v-if="isBatchDetailsFlow" @select="$emit('addToCurrentBatch')">
      <template #icon><span v-html="icons.existing_batch" class="flex items-center shrink-0" /></template>
      Add to <b>this</b> Batch
    </AppDropdownItem>

    <AppDropdownItem @select="$emit('createNewBatch')">
      <template #icon><span v-html="icons.blank_batch" class="flex items-center shrink-0" /></template>
      Create a new batch
    </AppDropdownItem>

    <AppDropdownItem @select="$emit('cdpBatchesSearch')">
      <template #icon><span v-html="icons.existing_batch" class="flex items-center shrink-0" /></template>
      {{ batchStore.selectedBatch ? "Add to an existing batch" : "Add to a batch" }}
    </AppDropdownItem>
  </AppDropdown>
</template>
